module.exports = __webpack_public_path__ + "img/DELETE.65defed7.svg";